import jwt from "jwt-decode";
import { checkNull, isObjectNull } from "utils/utils";


const USER_INFO_KEY = "user-info-key";
const TOKEN_KEY = "user-token";
const USER_REFRESH_TOKEN_KEY = "user-refresh-token";
const TOEKN_TIMEOUT_KEY = "token-timeout-key";
const TOEKN_TIMEOUT = 1000;
const identitySeverApiUrl = process.env.REACT_APP_IdentityServer_Doamin;

const serviceUrl = "/Authenticate/Login";
const userServiceUrl = "/User/";


const isTokenExpired = token => {
  try {
    const decoded = jwt(token);
    if (decoded.exp < Date.now() / TOEKN_TIMEOUT) {
      return true;
    } else return false;
  } catch (err) {
    return false;
  }
};

const clearLastLoginData = () => {
  localStorage.clear();
};

const setAuthToken = (user, refreshToken) => {
  localStorage.setItem(USER_INFO_KEY, JSON.stringify(user.data));
  localStorage.setItem(TOKEN_KEY, user.token);
  localStorage.setItem(USER_REFRESH_TOKEN_KEY, user.refreshToken);
  // localStorage.setItem(TOEKN_TIMEOUT_KEY, (new Date().setMinutes(2)).toString());
};

const setAuthTokenWithRefreshToken = (tokens) => {
  localStorage.setItem(TOKEN_KEY, tokens.token);
  localStorage.setItem(USER_REFRESH_TOKEN_KEY, tokens.refreshToken);
  // localStorage.setItem(TOEKN_TIMEOUT_KEY, (new Date().setMinutes(2)).toString());
};

export function authenticationService(http) {
  return {
    login: async user => {
      clearLastLoginData();
      const result = await http.post(serviceUrl, user);
      if (result.data.isSuccess) {
        setAuthToken(result.data.data);
        return result.data;
      } else {
        return false;
      }
    },
    checkUserCurrentPasswordAsync: async user => {
      const result = await http.post(userServiceUrl + 'CheckUserCurrentPasswordAsync',user);
      if (result.data) {
        return result.data;
      } else {
        return false;
      }
    },
    changePasswordAsync: async user => {
      const result = await http.post(userServiceUrl + 'ChangePasswordAsync',user);
      if (result.data.isSuccess) {
        setAuthToken(result.data.data);
        return result.data;
      } else {
        return false;
      }
    },
    // getPasswordValidationCodeAsync: async (userId, duration) => {
    //   let params = {
    //     userId: userId,
    //     duration: duration
    //   };
    //   const result = await http.post(userServiceUrl + 'GetPasswordValidationCodeAsync',params);
    //   if (result.status === 200) {
    //     return result.data
    //   } else {
    //     return {}
    //   }
    // },
    newTokenWithRefreshToken: async () => {
      const refreshToken = localStorage.getItem('user-refresh-token');
      const apiUrl = '/Authenticate/NewTokenWithRefreshToken/' + refreshToken;
      const result = await http(apiUrl);
      if (result.data && result.data.isSuccess) {
        setAuthTokenWithRefreshToken(result.data.data);
        return true;
      } else {
        return false;
      }
    },
    getCompressedToken: async (userId, normalizedUserName) => {
      var model = {
        userId: userId,
        userName: normalizedUserName
      };

      return await http.post("/Authenticate/GenerateCompressToken", model)
    },
    logout: (history = null) => {
      localStorage.removeItem(TOKEN_KEY);
      if (!isObjectNull(history)) {
        history.replace({
          pathname: '',
          search: ''
       });
      }
      window.location.reload();
    },
    isLogin: () => {
      const token = localStorage.getItem(TOKEN_KEY);
      //const isTokenExpried = isTokenExpired(token);
      //return !!token && isTokenExpried;
      return token ? true : false;
    }
  };
}
